<template>
  <nav>
    <router-link to="/streets">Streets</router-link> |
    <router-link to="/portraits">Portraits</router-link> |
    <router-link to="/publications">Publications</router-link> |
    <router-link to="/">About</router-link>
  </nav>
  <router-view/>
  <br>
  <br>
  <br>
  <br>
  <footer>
    <div title="Respect the property rights and don't be a fucking cunt">
      Proper hyperlink citation is required when using materials from this resource; <router-link to="/license">License</router-link>
      <br>
      <a class="nav.a" href="mailto:contact@keyreal.photography" target="_blank">Get in touch</a>
      <br>
      © 2024, Powered by <a href="https://github.com/iddqdiddqd" target="_blank">iddqdiddqd</a>
    </div>
  </footer>
</template>

<style>
  @import '@/styles/main.css';
</style>
